import { fetchVimeoOembedData } from '../utils/vimeo';
import { uniqify } from '../utils/url';
import { loadTitleDataSuccess } from './titleActions';


export const loadPlaylistData = (titleProps) => (dispatch, getState) => {
  const { uid, items, ...rest } = titleProps;
  const playlistData = { uid, ...rest };

  // Flat map of playlist items by uid
  playlistData.itemsById = items.reduce((itemsObj, item) => {
    const { items: childItems, ...rest } = item;
    if (itemsObj.hasOwnProperty(item.uid)) {
      console.error(`Duplicate uid in title ${uid}: ${item.uid}`);
    }
    itemsObj[item.uid] = { ...rest };
    if (childItems && childItems.length !== 0) {
      childItems.forEach(childItem => {
        if (itemsObj.hasOwnProperty(childItem.uid)) {
          console.error(`Duplicate uid in title ${uid}: ${childItem.uid}`);
        }
        itemsObj[childItem.uid] = { ...childItem, group: item.uid };
      });
    }
    return itemsObj;
  }, {});

  // Array defining order and hierarchy of items
  playlistData.itemsOrdered = items.map(item => {
    const { uid, items } = item;
    const out = { uid };
    if (items && items.length !== 0) {
      out.childItems = items.map(item => item.uid);
    }
    return out;
  });

  // Array mapping deduplicated URL slugs to UIDs
  playlistData.itemUrls = Object.keys(playlistData.itemsById).reduce((result, key) => {
    const item = playlistData.itemsById[key];
    if (item.type === 'media') {
      // Only 'media' items have a direct URL, not groups or labels.
      const keys = Object.keys(result);
      const uniqSlug = uniqify(item.media.slug, keys);
      result[uniqSlug] = item.uid;
    }
    return result;
  }, {});

  // Item that should display by default when the Playlist loads.
  // Currently defaults to the first playable item (TODO configurable in backend).
  let firstItem = items.find(item => item.type === 'media' || (item.type === 'group' && item.items.length > 0));
  if (firstItem.type === 'group') {
    firstItem = firstItem.items[0];
  }
  playlistData.defaultItemId = firstItem.uid;

  const mergeVimeoData = (item, vimeoMetadata) => {
    const vimeoId = item.metadata.sourceId;
    if (!(vimeoId in vimeoMetadata)) {
      return false;
    }

    const { duration, thumbnailUrl, width, height } = vimeoMetadata[vimeoId];
    item.poster = item.poster || thumbnailUrl;
    item.thumbnail = item.thumbnail || thumbnailUrl; // TODO remove this
    item.width = width;
    item.height = height;
    if (duration) {
      item.duration = duration;
    }
  };

  // Build a deduplicated list of all Vimeo URLs
  const vimeoUrls = Object.keys(playlistData.itemsById)
    .map(uid => playlistData.itemsById[uid]) // map UIDs to objects
    .filter(({ type }) => type === 'media') // exclude groups and labels
    .map(({ media }) => {
      // extract vimeo urls
      const { sourceUrl, sourceId } = media.metadata || {};
      return sourceUrl || (sourceId ? `https://vimeo.com/${sourceId}` : null);
    })
    .filter((elem, i, arr) => elem && arr.indexOf(elem) === i); // deduplicate

  // Fetch metadata from Vimeo API and merge in to playlist data
  const vimeoMetadata = {};
  const promises = vimeoUrls.map(url => fetchVimeoOembedData(url));
  Promise.all(promises)
    .then(results => {
      results.forEach(res => {
        if (typeof res !== 'undefined' && Object.keys(res).length) {
          const { videoId, ...rest } = res;
          vimeoMetadata[videoId] = rest;
        }
      });
    })
    .then(() => {
      // Add data from Vimeo API
      Object.keys(playlistData.itemsById).forEach(uid => {
        const item = playlistData.itemsById[uid];
        if (item.media && item.media.metadata.sourceId) {
          mergeVimeoData(item.media, vimeoMetadata);
        }
      });

      // Annotate group objects with thumbnail and total duration of included clips
      playlistData.itemsOrdered.forEach(item => {
        if (item.childItems) {
          const record = playlistData.itemsById[item.uid];
          const groupDuration = item.childItems.reduce((total, childId) => {
            total += playlistData.itemsById[childId].media.duration || 0;
            return total;
          }, 0);
          record.duration = groupDuration;
          const minutesRounded = Math.round(groupDuration / 60);
          if (minutesRounded > 0) {
            // TODO: i18n hardcoded string
            record.durationFriendly = `${minutesRounded} ${minutesRounded === 1 ? 'minute' : 'minutes'}`;
          } else if (groupDuration > 0) {
            record.durationFriendly = `${groupDuration} seconds`;
          }

          record.thumbnail = record.thumbnail || playlistData.itemsById[item.childItems[0]].thumbnail;
        }
      });
      dispatch(loadTitleDataSuccess(playlistData));
    })
    .catch(e => console.error(e));
};



// WEBPACK FOOTER //
// ./src/actions/playlistTitleActions.js